import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ITagsList} from '../../api/types/tagFoldering.type';
import {ExtendedTreeItemProps} from '../../shared/interfaces';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';
import {ReportActionMenuOptionTypes} from '../../shared/constants';

export const TAGS_ACTION_MENU: CustomMenuItem[] = [
  {
    id: 'new_tag',
    label: 'New Tag',
    disabled: false,
  },
  {
    id: 'new_tag_group',
    label: 'New Tag Group',
    disabled: false,
  },
  {
    id: 'edit',
    label: 'Edit',
    disabled: false,
  },
  {
    id: 'delete',
    label: 'Delete',
    disabled: false,
  },
  {
    id: 'view',
    label: 'View',
    disabled: false,
    submenu: [
      {
        id: 'view_in_docView',
        label: 'View in Doc View',
        disabled: false,
      },
      {
        id: 'view_in_docView_in_new_tab',
        label: 'View in Doc View in New Tab',
        disabled: false,
      },
      {
        id: 'view_in_docList',
        label: 'View in Doc List',
        disabled: false,
      },
    ],
  },
  {
    id: ReportActionMenuOptionTypes.BulkRelease,
    label: 'Bulk Release',
    disabled: false,
  },
];

export const FOLDERS_ACTION_MENU: CustomMenuItem[] = [
  {
    id: 'new_folder',
    label: 'New Folder',
    disabled: false,
  },
  {
    id: 'new_folder_group',
    label: 'New Folder Group',
    disabled: false,
  },
  {
    id: 'edit',
    label: 'Edit',
    disabled: false,
  },
  {
    id: 'delete',
    label: 'Delete',
    disabled: false,
  },
  {
    id: 'view',
    label: 'View',
    disabled: false,
    submenu: [
      {
        id: 'view_in_docView',
        label: 'View in Doc View',
        disabled: false,
      },
      {
        id: 'view_in_docView_in_new_tab',
        label: 'View in Doc View in New Tab',
        disabled: false,
      },
      {
        id: 'view_in_docList',
        label: 'View in Doc List',
        disabled: false,
      },
    ],
  },
  {
    id: ReportActionMenuOptionTypes.BulkRelease, // ✅ Changed from 'bulk_release'
    label: 'Bulk Release',
    disabled: false,
  },
];

export const buildTree = (items: ITagsList[] = []) => {
  const nodeMap: any = {};
  items.forEach((it: ITagsList) => {
    nodeMap[it.id] = {
      ...it,
      label: it.text,
      fileType: it.isGroup
        ? it.type === 'tags'
          ? 'tag_group'
          : 'folder_group'
        : '',
      skipParent: it.parent === '-1',
    };
    delete nodeMap[it.id].children;
  });

  const roots: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];
  items.forEach((it: ITagsList) => {
    const node = nodeMap[it.id];
    const parentId = it.parent;
    if (!parentId || !nodeMap[parentId]) roots.push(node);
    else {
      const parent = nodeMap[parentId];
      if (!parent.children) parent.children = [];
      parent.children.push(node);
    }
  });

  Object.values(nodeMap).forEach((n: any) => {
    n.hasChildren = Array.isArray(n.children) && n.children.length > 0;
  });

  return roots;
};

export const findNodeById = (
  nodes: TreeViewBaseItem<ExtendedTreeItemProps>[],
  id: string
): TreeViewBaseItem<ExtendedTreeItemProps> | null => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};
